<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';

const { t } = useI18n();
const registerStore = useRegisterStore();

const is_country_ghana = process.env.VUE_APP_COUNTRY == 'GHANA';

</script>

<template>
	<div class="register-form-field">
		<label v-if="is_country_ghana" >{{$t('account.register.address_without_street')}}</label>
		<label v-else >{{$t('account.register.address')}}</label>

		<input class="form-input" :placeholder="$t('account.register.address')" @keyup="registerStore.validateStreetName" v-model="registerStore.register_input_fields.street_name" type="text" name="city"
		required="required" />
		<div class="register-form-list" v-if="registerStore.register_errors.street_name.error">
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<span v-if="registerStore.register_errors.street_name.error === 'error_only_characters_and_numbers'">
					{{ $t('account.register.error_only_characters_and_numbers') }}
				</span>
				<span v-else-if="registerStore.register_errors.street_name.error === 'error_address_required'">
					{{ $t('account.register.error_address_required') }}
				</span>
				<span v-else-if="registerStore.register_errors.hasOwnProperty('street_name')">
					{{ registerStore.register_errors.street_name.error }}
				</span>
			</p>
		</div>
	</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>